var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2689,
	"./chat-icon-bottom-nav-mobile.webp": 2690,
	"./home-icon-bottom-nav-mobile-active.webp": 2691,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2692,
	"./home-icon-bottom-nav-mobile.webp": 2693,
	"./home-icon-bottom-nav-mobile_b.webp": 2694,
	"./me-icon-bottom-nav-mobile-active.webp": 2695,
	"./me-icon-bottom-nav-mobile.webp": 2696,
	"./promo-icon-bottom-nav-mobile-active.webp": 2697,
	"./promo-icon-bottom-nav-mobile.webp": 2698,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2699,
	"./sponsor-icon-bottom-nav-mobile.webp": 2700,
	"./stream-icon-bottom-nav-mobile-active.webp": 2701,
	"./stream-icon-bottom-nav-mobile.webp": 2702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2688;